<template>
  <div>
    <b-card>
      <div slot="header">
        <i
          class="fa fa-list-ul"
          aria-hidden="true"
        ></i>
        History
      </div>
      <b-alert
        variant="success"
        :show="successMessage != ''"
      > {{ successMessage }} </b-alert>
      <b-alert
        class="text-center"
        :show="errorMessage != ''"
        variant="danger"
        dismissible
      > {{ errorMessage }} </b-alert>
      <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
      <b-row>
        <b-col sm>
          <label>App Name</label>
          <b-form-input
            id="appname"
            v-model="form.appName"
            type="text"
            placeholder="Enter app name"
          ></b-form-input>
        </b-col>
        <b-col sm>
          <label for="sendTo">Start - End Date</label>
          <v-date-picker
            mode='range'
            locale="th-TH"
            color="gray"
            :columns="$screens({ default: 1, lg: 2 })"
            :popover="{ visibility: 'click' }"
            :input-props="{ placeholder: 'Please enter date start and finish', readonly: true }"
            v-model='form.dateRange'
          >
          </v-date-picker>
          <label for="sendTo">Start - End Time</label>
          <autocomplete-vue
            :list="time"
            placeholder="Enter start time"
            inputClass="form-control"
            v-model="form.startTime"
          ></autocomplete-vue>
          <div class="fix-font"> To </div>
          <autocomplete-vue
            :list="time"
            placeholder="Enter end time"
            inputClass="form-control"
            v-model="form.endTime"
          ></autocomplete-vue>
        </b-col>
        <b-col sm>
          <label>Platform</label>
          <b-form-select v-model="form.platform">
            <option value="all">All</option>
            <option value="ios">iOS</option>
            <option value="android">Android</option>
          </b-form-select>
        </b-col>
        <b-col sm>
          <label>Type</label>
          <b-form-select v-model="form.type">
            <option value="token">token</option>
            <option value="refId">refId</option>
            <option value="tag">tag</option>
          </b-form-select>
        </b-col>
        <b-col sm>
          <label>Type Value</label>
          <b-form-input
            id="typeValue"
            v-model="form.typeValue"
            type="text"
            placeholder="Enter type value"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm>
          <hr />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm>
          <b-button
            block
            variant="success"
            @click="getHistory"
          >Search</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <alert-fail :show="isError"> {{ errorMessage }} </alert-fail>
          <b-table
            stacked="sm"
            :busy="isBusy"
            :current-page="currentPage"
            :per-page="numberPerPage"
            class="table-app"
            tbody-class="tbody"
            hover
            thead-tr-class="thead-app"
            :fields="fields"
            :items="list"
          >
            <template
              slot="time"
              slot-scope="row"
            >
              {{ row.item.time }}
            </template>
            <template
              slot="success"
              slot-scope="row"
            >
              {{ row.item.success }}
            </template>
            <template
              slot="fail"
              slot-scope="row"
            >
              {{ row.item.fail }}
            </template>
            <template
              slot="platform"
              slot-scope="row"
            >
              {{ row.item.platform }}
            </template>
            <template
              slot="message"
              slot-scope="row"
            >
              {{ row.item.message }}
            </template>
            <template
              slot="message_details"
              slot-scope="row"
            >
              <b-button
                size="sm"
                @click="row.toggleDetails"
              >{{ row.detailsShowing ? 'Hide' : 'Show'}}</b-button>
            </template>
            <template v-slot:row-details="row">
              <b-card>
                <b-card-body title="Success">
                  <b-card-text v-html="row.item.successDetail">
                  </b-card-text>
                </b-card-body>
                <b-card-body title="Fail">
                  <b-card-text v-html="row.item.failDetail">
                  </b-card-text>
                </b-card-body>
                <b-card-body title="Message">
                  <b-card-text v-html="row.item.messageDetail">
                  </b-card-text>
                </b-card-body>
                <b-button
                size="sm"
                @click="row.toggleDetails"
              >Hide Details</b-button>
              </b-card>
            </template>
            <div
              slot="table-busy"
              class="text-center text-dark my-2"
            >
              <b-spinner
                variant="dark"
                class="align-middle"
              ></b-spinner>
              <strong>Loading...</strong>
            </div>
          </b-table>
          <hr />
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="numberPerPage"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import AlertFail from '../../components/alert/AlertFail';
import { timeAutoComplete, getTimestamp } from '@/assets/utils/time';
import AutocompleteVue from 'autocomplete-vue';
import Loading from '@/components/Loading';

export default {
  data () {
    return {
      form: {},
      isLoading: false,
      isBusy: false,
      numberPerPage: 10,
      fields: [
        { key: 'time' },
        { key: 'success' },
        { key: 'fail' },
        { key: 'platform' },
        { key: 'message' },
        { key: 'message_details' }
      ],
      list: [],
      isError: false,
      successMessage: '',
      errorMessage: '',
      currentPage: 1,
      totalRows: 1
    };
  },
  methods: {
    async getHistory () {
      const page = 1;
      const appName = this.form.appName || '';
      const platform = this.form.platform || '';
      const type = this.form.type || '';
      const typeValue = this.form.typeValue || '';

      const dateStart = this.form.dateRange ? this.form.dateRange.start : '';
      const dateStop = this.form.dateRange ? this.form.dateRange.end : '';
      const timeStart = this.form.startTime || '';
      const timeEnd = this.form.endTime || '';
      const reDateStart = dateStart !== '' ? new Date(dateStart).toDateString() + ' ' + timeStart : '';
      const reDateEnd = dateStop !== '' ? new Date(dateStop).toDateString() + ' ' + timeEnd : '';
      const unixStartTime = reDateStart !== '' ? getTimestamp(new Date(reDateStart)) : '';
      const unixEndTime = reDateEnd !== '' ? getTimestamp(new Date(reDateEnd)) : '';
      this.list = [];
      const searchString = `page=${page}&appName=${appName}&timeStart=${unixStartTime}&timeEnd=${unixEndTime}&platform=${platform}&type=${type}&typeValue=${typeValue}`;
      try {
        const notificationsResponse = await this.axios.get(`${process.env.VUE_APP_URL_MESSAGING_API}/history/notification?${searchString}`);
        const notifications = notificationsResponse.data.data;

        for (const noti of notifications) {
          let platform = '';
          let success = '';
          let successDetail = '';
          let fail = '';
          let failDetail = '';
          let message = '';
          let messageDetail = '';

          platform = noti.to ? noti.to.platform : '';
          message = noti.to ? noti.to.value : '';
          messageDetail = noti.notification ? 'Title : ' + noti.notification.title + '<br/>' + 'Message : ' + noti.notification.message + '<br/>' + 'Badge : ' + noti.notification.badge + '<br/>' + 'Payload : ' + this.getJsonPropData(noti.notification.payload) : '';
          if (noti.result.android) {
            if (noti.result.android.success.length > 0) {
              success = 'Android';
              successDetail = success + '<br/>';
              for (let msg of noti.result.android.success) {
                successDetail += msg + '<br/>';
              }
            }
            if (noti.result.android.fail.length > 0) {
              fail = 'Android';
              failDetail += fail + '<br/>';
              for (let msg of noti.result.android.fail) {
                failDetail += this.getJsonPropData(msg) + '<br/>';
              }
            }
          }
          if (noti.result.ios) {
            if (noti.result.ios.success.length > 0) {
              success = 'iOS';
              successDetail += success + '<br/>';
              for (let msg of noti.result.ios.success) {
                successDetail += msg + '<br/>';
              }
            }
            if (noti.result.ios.fail.length > 0) {
              fail = 'iOS';
              failDetail += fail + '<br/>';
              for (let msg of noti.result.ios.fail) {
                failDetail += this.getJsonPropData(msg) + '<br/>';
              }
            }
          }

          this.list.push({
            time: new Date(noti.time).toLocaleString(),
            platform: platform,
            success: success,
            successDetail: successDetail,
            fail: fail,
            failDetail: failDetail,
            message: message,
            messageDetail: messageDetail
          });
        }
      } catch (e) {
        this.errorMessage = e.response.data.message;
        if ('UAT-003' === e.response.data.code) {
          this.$router.push({ name: 'login' });
        }
      }

      this.totalRows = this.list.length;
      this.isBusy = false;
      return this.list;
    },
    getJsonPropData (payload) {
      let payloadText = '';
      for (let p in payload) {
        payloadText += p + ': ' + payload[p] + '<br>';
      }
      return payloadText;
    }
  },
  computed: {
    time () {
      return timeAutoComplete();
    },
    unixTime () {
      return new Date().getTime();
    }
  },
  created () {
    document.title = 'Admin Console: Messaging History';
  },
  components: {
    AlertFail,
    'app-loading': Loading,
    AutocompleteVue
  }
};
</script>
